const specs = {
  width: 620,
  title: {
    update: 'pages.preventiveMeasures.modal.update.single.title',
    create: 'pages.preventiveMeasures.modal.create.single.title'
  },
  okText: {
    update: 'pages.preventiveMeasures.modal.update.single.okText',
    create: 'pages.preventiveMeasures.modal.create.single.okText'
  },
  actions: {
    delete: {
      buttonType: 'danger'
    }
  },
  rows: {
    name: {
      title: 'pages.preventiveMeasures.fields.name.title',
      dataIndex: 'name',
      key: 'name',
      formField: {
        label: 'pages.preventiveMeasures.fields.name.title',
        required: 'pages.preventiveMeasures.fields.name.requiredMessage',
        placeholder: 'pages.preventiveMeasures.fields.name.placeholder'
      },
      empty: 'common.unknown.male'
    }
  }
}

export default specs
